const hostname = window.location.hostname;

let config = {
  API_URL: 'http://localhost:3100/',
  IMAGE_URL: 'http://localhost:3100/gambar/',
  ELOG_API: 'http://18.139.198.78/elogapiv2/',
  AWS_URL: 'https://s3.ap-southeast-1.amazonaws.com/cache.fli.id/dev/cms/',
  nodeEnv: 'local',
  token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJtc3RfZW1wbG95ZWVfaWQiOjEsIm1zdF9lbXBsb3llZV9uYW1lIjoiQURNSU5JU1RSQVRPUiIsIm1zdF9lbXBsb3llZV9uaWsiOiIwMDAwMDAwMCIsIm1zdF9lbXBsb3llZV9lbWFpbCI6ImFkbWluaXN0cmF0b3JAbWFpbC5jb20iLCJtc3RfY29ycG9yYXRlX2lkIjoyLCJtc3RfY29ycG9yYXRlX25hbWUiOiJQVCBGQVNUQU5BIExPR0lTVElLIElORE9ORVNJQSIsIm1zdF9zaXRlX2lkIjoyLCJtc3Rfc2l0ZV9uYW1lIjoiRlNMSSBQVVNBVCIsIm1zdF9wb3NpdGlvbl9pZCI6bnVsbCwibXN0X3Bvc2l0aW9uX2xldmVsIjpudWxsLCJtc3RfcG9zaXRpb25fbmFtZSI6bnVsbCwibXN0X2RpdmlzaW9uX2lkIjpudWxsLCJtc3RfZGl2aXNpb25fbmFtZSI6bnVsbCwibXN0X2RpdmlzaW9uX2FsaWFzIjpudWxsLCJncm91cF9pZCI6MSwiaWF0IjoxNzY3MDYyNDg1LCJleHAiOjE3Njc2NjcyODV9.xl05w0B7mnFCzRtEjJlJKCdIZcz1o5kRqBpFDPujI5A"
};

if (hostname === 'aces.loneless.xyz') {
  config = {
    AWS_URL: 'https://s3.ap-southeast-1.amazonaws.com/cache.fli.id/dev/cms/',
    API_URL: 'https://aces-api.loneless.xyz/',
    IMAGE_URL: 'https://aces-api.loneless.xyz/gambar/',
    ELOG_API: 'http://18.139.198.78/elogapiv2/',
    nodeEnv: 'development',
    url_FE: 'https://ssov3.loneless.xyz'
  };
} else if (hostname === 'aces.fli.co.id') {
  config = {
    AWS_URL: 'https://s3.ap-southeast-1.amazonaws.com/cache.fli.id/prod/cms/',
    API_URL: 'https://aces-api.fli.co.id/',
    IMAGE_URL: 'https://aces-api.fli.co.id/gambar/',
    ELOG_API: 'http://18.139.198.78/elogapiv2/',
    nodeEnv: 'production',
    url_FE: 'https://sso.fli.co.id'
  };
}

export default config;
